import React from 'react'
import { retrieveConfig } from '../../config/config'
import { sendPostMessage } from '../../utils/post-message'

export default class ModalFooter extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showCloseButton: false,
        }
    }

    async componentDidMount() {
        try {
            const selectedConfig = await retrieveConfig()
            if (selectedConfig) {
                this.setState({ config: selectedConfig })
            }
        } catch (error) {
            console.error('Error retrieving config:', error)
        }

        // Set a timer to show the close button after 3 seconds
        this.closeButtonTimer = setTimeout(() => {
            this.setState({ showCloseButton: true })
        }, 3000)
    }

    componentWillUnmount() {
        // Clear the timer if the component unmounts
        if (this.closeButtonTimer) {
            clearTimeout(this.closeButtonTimer)
        }
    }

    toggle = () => {
        // if opened as a popup window, close the window
        if (window.opener && !window.opener.closed) {
            sendPostMessage('WINDOW_CLOSED', {
                reason: 'User closed payment modal by the user',
            })

            window.close()

            return
        }

        // Destroy the DataMesh instance
        window?.DataMesh?.destroy()

        // Dispatch a custom event that PaymentModel can listen for
        document.dispatchEvent(
            new CustomEvent('closePaymentModal', {
                detail: { closed: true },
            }),
        )
    }

    render() {
        const primaryColor = this.state.config?.colorTheme?.secondaryColor ?? '#334155'
        const closeText = this.state.config?.form?.closeText ?? ''

        // Privacy Policy link for the SDK footer.
        const privacyPolicyUrl = this.state.config?.privacyPolicyUrl ?? 'https://www.db.com/legal-resources/privacy-notice'
        const privacyPolicyText = this.state.config?.privacyPolicyText ?? 'Privacy Policy'

        return (
            <div className="modal-footer w-100">
                <div
                    className="modal-footer"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '8px',
                        marginTop: '15px',
                    }}
                >
                    {/* Hidden until the mount timer flips showCloseButton */}
                    {closeText && (
                        <button
                            className=" z-10 outline-none focus:outline-none  ease-linear transition-all duration-150"
                            type="button"
                            onClick={() => this.toggle()}
                            style={{
                                opacity: this.state.showCloseButton ? 1 : 0,
                                visibility: this.state.showCloseButton ? 'visible' : 'hidden',
                                transition: 'opacity 0.5s ease-in-out, visibility 0.5s ease-in-out',
                                padding: '10px 20px',
                                color: primaryColor,
                                textDecoration: 'underline',
                                textTransform: 'capitalize',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                            }}
                        >
                            {closeText}
                        </button>
                    )}

                    <a
                        href={privacyPolicyUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${privacyPolicyText} (opens in new tab)`}
                        style={{
                            color: primaryColor,
                            fontSize: '12px',
                            textDecoration: 'underline',
                            opacity: 0.7,
                        }}
                    >
                        {privacyPolicyText}
                    </a>
                </div>
            </div>
        )
    }
}
